import React, { useState, useEffect } from "react";
import { Col, Form, Row } from 'react-bootstrap';

import { useTranslation } from "react-i18next";


function DripForm(props) {
  const { t, i18n } = useTranslation();


  return (
    <Row className="d-flex gap-2 justify-content-between">
      <Col lg="4" md="12" sm="12" className="form-group">
        <Form.Group controlId="irrig-drip-flowrate">
          <Form.Label>{t('FlowRate')} (l/h) *</Form.Label>
          <Form.Control
            type="number"
            value={props.flowrate}
            placeholder={t('FlowRate')}
            required
            onChange={props.handleFlowRate}
          />
        </Form.Group>
      </Col>
      <Col lg="3" md="12" sm="12" className="form-group">
        <Form.Group controlId="irrig-drip-drippers">
          <Form.Label>{t('Drippers')} (pieds) *</Form.Label>
          <Form.Control
            type="number"
            value={props.drippers}
            placeholder={t('Drippers')}
            required
            onChange={props.handleDrippers}
          />
        </Form.Group>
      </Col>
      <Col lg="4" md="12" sm="12" className="form-group">
        <Form.Group controlId="irrig-drip-spacing">
          <Form.Label>{t('espace_drippers')} (m) *</Form.Label>
          <Form.Control
            type="number"
            value={props.drippersSpacing}
            placeholder={t('espace_drippers')}
            required
            onChange={props.handleDrippersSpacing}
          />
        </Form.Group>
      </Col>
    </Row>
  );
}

export default DripForm;
